import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=3144fe34&scoped=true&"
import script from "./forgetPass.vue?vue&type=script&lang=js&"
export * from "./forgetPass.vue?vue&type=script&lang=js&"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=3144fe34&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144fe34",
  null
  
)

export default component.exports